<template>
  <div class="container-dashboard">
      <div class="container-dashboard-content">
        <VuePerfectScrollbar class="sidebar-left" v-once>
            <div class="sidebar-left-header">
              Notification
            </div>
            <template  v-for="(notification, index) in notifications">
              <div class="sidebar-left-body" :key="index">
                <div class="sidebar-left-item sidebar-title">
                  {{ notification.title }}
                </div>
                <template v-for="(itemsNotification, indexNotification) in notification.data">
                  <a class="sidebar-left-item sidebar-content" href="javascript:void(0)" :key="indexNotification">
                    <div class="content-title">{{ itemsNotification.title }}</div>
                    <div class="content-date">{{ itemsNotification.date }}</div>
                  </a>
                </template>
              </div>
            </template>
        </VuePerfectScrollbar>
        <div class="content">
          <b-container fluid>
            <b-row>
              <b-col cols="12">
                <CaseBox @selectedType="handleSelectedType"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pr-0">
                <CaseList :status="status"/>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  const CaseBox = () => import('./dashboard-cases/CaseBox')
  const CaseList = () => import('./dashboard-cases/CaseDashboard')

  export default {
    components: {
      VuePerfectScrollbar,
      CaseBox,
      CaseList
    },
    data: function() {
      return {
        notifications: [
          {
            'title': 'Today 11.07.2019',
            'data': [
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Today, 14:00'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Today, 15:00'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Today, 17:00'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Today, 18:00'},
            ]
          },
          {
            'title': 'Yesterday 10.07.2019',
            'data': [
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Yesterday, 14:00'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Yesterday, 15:00'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Yesterday, 17:00'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Yesterday, 18:00'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Yesterday, 18:00'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Yesterday, 18:02'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Yesterday, 18:03'},
              {'title':'CA-NHT-2111-0216 assigned to Gofix','date':'Yesterday, 18:04'},
            ]
          }
        ],
        item_id: null,
        status: ''
      }
    },
    methods: {
      handleSelectedType(type) {
        this.status = type;
      },
    }
  }
</script>